import * as $$ from 'rxjs';

/* eslint-disable import/no-deprecated */
import {
  buffer,
  bufferCount,
  catchError,
  concatMap,
  debounce,
  debounceTime,
  defaultIfEmpty,
  delay,
  distinctUntilChanged,
  expand,
  filter,
  finalize,
  find,
  first,
  flatMap,
  last,
  map,
  mapTo,
  mergeAll,
  mergeMap,
  pairwise,
  pluck,
  reduce,
  scan,
  share,
  shareReplay,
  skip,
  skipUntil,
  skipWhile,
  startWith,
  switchAll,
  switchMap,
  switchMapTo,
  take,
  takeUntil,
  takeWhile,
  tap,
  throttle,
  throttleTime,
  toArray,
  withLatestFrom,
} from 'rxjs/operators';

export const rx = {
  buffer,
  bufferCount,
  catchError,
  concatMap,
  debounce,
  debounceTime,
  defaultIfEmpty,
  delay,
  distinctUntilChanged,
  expand,
  filter,
  finalize,
  find,
  first,
  flatMap,
  last,
  map,
  mapTo,
  mergeAll,
  mergeMap,
  pairwise,
  pluck,
  reduce,
  scan,
  share,
  shareReplay,
  skip,
  skipUntil,
  startWith,
  switchAll,
  switchMap,
  switchMapTo,
  take,
  takeUntil,
  takeWhile,
  tap,
  throttle,
  throttleTime,
  toArray,
  withLatestFrom,
  skipWhile,
};

import { webSocket } from 'rxjs/webSocket';

export const rxWebSocket = {
  webSocket,
};

import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounce';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/find';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/combineAll';
import { fromPromise } from 'rxjs/internal-compatibility';

// eslint-disable-next-line import/no-deprecated
export const observableCombineLatest = $$.combineLatest;
export const observableRace = $$.race;
export const observableDefer = $$.defer;
export const observableEMPTY = $$.EMPTY;
export const observableNEVER = $$.NEVER;
export const observableForkJoin = $$.forkJoin;
export const observableFrom = $$.from;
export const observableFromEvent = $$.fromEvent;
export const observableFromPromise = fromPromise;
export const observableInterval = $$.interval;
export const observableMerge = $$.merge;
export const observableOf = $$.of;
export const observableIIF = $$.iif;
export const observableThrowError = $$.throwError;
export const observableTimer = $$.timer;
export const observableZip = $$.zip;
export const observableConcat = $$.concat;
export const isObservable = $$.isObservable;

export { ErrorObservable } from 'rxjs/observable/ErrorObservable';
export {
  AsyncSubject,
  BehaviorSubject,
  Observable,
  ReplaySubject,
  Subject,
  Subscription,
} from 'rxjs';

export { WebSocketSubject, WebSocketSubjectConfig } from 'rxjs/webSocket';
